module.exports = __webpack_public_path__ + "img/gallery14.94fba31b.jpg";